import parsePhoneNumberFromString from 'libphonenumber-js'

export function formatPhone(phone: string): string | undefined {
  if (!phone) return
  const parsed = parsePhoneNumberFromString(phone)
  return parsed?.format('INTERNATIONAL', {
    humanReadable: true,
    fromCountry: parsed.country,
  })
}
